<template>
  <div class="row q-col-gutter-md">
    <div class="col-12 col-lg-8">
      <div class="row q-col-gutter-md">
        <div class="col-12 col-sm-6">
          <clients-added-card :account-id="accountId" />
        </div>
        <div class="col-12 col-sm-6">
          <law-firm-users-card :account-id="accountId" />
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-4">
      <resources-card />
    </div>
  </div>
</template>

<style>
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import recognition from '@/auth/recognition';
import ClientsAddedCard from './ClientsAddedCard.vue';
import LawFirmUsersCard from './LawFirmUsersCard.vue';
import ResourcesCard from './ResourcesCard.vue';

export default defineComponent({
  components: {
    ClientsAddedCard,
    LawFirmUsersCard,
    ResourcesCard,
  },
  props: {
    accountId: {
      type: Number,
      default() {
        return recognition.getAccountId();
      },
    },
    userId: {
      type: Number,
      default() {
        return recognition.getUserId();
      },
    },
  },
});
</script>
